import * as types from './mutation-types'
import util from '@/util'

export default {
  [types.SET_DADOS_AGENDA] (state, respostaAgenda) {
    state.agenda.caldavSyncAllowed = respostaAgenda.caldav.caldavSyncAllowed
    state.agenda.formulario.enableCaldavSync = respostaAgenda.caldav.f_caldav
    state.agenda.formulario.enableIcalSync = respostaAgenda.caldav.icalSyncAllowed
    state.agenda.icalSyncAllowed = respostaAgenda.caldav.icalSyncAllowed
    if (state.agenda.caldavSyncAllowed === true && state.agenda.formulario.enableCaldavSync === true) {
      state.agenda.caldavData = respostaAgenda.caldav.caldavData
    } else if (state.agenda.icalSyncAllowed === true && state.agenda.formulario.enableCaldavSync === true) {
      state.agenda.caldavData = respostaAgenda.caldav.caldavData
    }
    if (!util.valorEhNulo(respostaAgenda.userSettings)) {
      state.agenda.formulario.enableAutomatedInviteConfirmation = respostaAgenda.userSettings.f_automated_invite_confirmation
      state.agenda.formulario.enableAutomatedInviteAcceptance = respostaAgenda.userSettings.f_automated_invite_acceptance
      state.agenda.formulario.enableViewCustomerBirthdays = respostaAgenda.userSettings.f_view_customer_birthdays
      state.agenda.formulario.enableViewEventAppointments = respostaAgenda.userSettings.f_view_event_appointments
      state.agenda.formulario.enableViewEventHearings = respostaAgenda.userSettings.f_view_event_hearings
      state.agenda.formulario.enableViewEventActivities = respostaAgenda.userSettings.f_view_event_activities
      state.agenda.formulario.enableViewSharingPersonal = respostaAgenda.userSettings.f_view_sharing_personal
      state.agenda.formulario.enableViewSharingBirthdays = respostaAgenda.userSettings.f_view_sharing_birthdays
      state.agenda.formulario.enableViewSharingActivities = respostaAgenda.userSettings.f_view_sharing_activities
      state.agenda.formulario.enableViewSharingAppointments = respostaAgenda.userSettings.f_view_sharing_appointments
      state.agenda.formulario.enableViewSharingHearings = respostaAgenda.userSettings.f_view_sharing_hearings
    }
  },
  [types.SET_RESETAR_DADOS_AGENDA] (state) {
    state.agenda.caldavSyncAllowed = false
    state.agenda.caldavData = null
  },
  [types.SET_DADOS_FORMULARIO_AGENDA] (state, formulario) {
    state.agenda.formulario = formulario
  },
  [types.SET_HABILITAR_OU_DESABILITAR_CALDAV] (state) {
    if (state.agenda.caldavSyncAllowed === false && state.agenda.icalSyncAllowed === false) {
      state.agenda.caldavData = null
    }
  },
  [types.SET_FLAGS_DE_CONTROLE] (state, flagsDeControle) {
    state.flagsDeControle = flagsDeControle
  },
  [types.SET_DADOS_RETORNO_CADASTRO] (state, dadosRetornoDoCadastro) {
    state.dadosRetorno.sucesso = dadosRetornoDoCadastro.sucesso
    state.dadosRetorno.listaDeErros = dadosRetornoDoCadastro.listaDeErros
    state.dadosRetorno.mensagem = dadosRetornoDoCadastro.mensagem
  }
}
